import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import config from '@@config';
import { textSearchParams } from '@@containers/Search/unitySearchParams';
import { requireRoles } from '@@router/guards';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { Layout } from './-components/Layout';
import { newsletterListQuery } from './-components/newsletterListQuery';

const requireNewsletterRoles = requireRoles(config.navigation.newsletters.authorize);

export const Route = createFileRoute('/_authenticated/newsletters')({
    validateSearch: textSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => textSearchParams.parse(search),
    beforeLoad: ({ search }) => {
        requireNewsletterRoles();

        const contentLocale = getContentLocale();

        // Built on every load, so the options follow the content language as well as the search
        return {
            allNewslettersQuery: newsletterListQuery({ q: search.q }, contentLocale),
            activeNewslettersQuery: newsletterListQuery(
                { q: search.q, active: true },
                contentLocale,
            ),
            inactiveNewslettersQuery: newsletterListQuery(
                { q: search.q, active: false },
                contentLocale,
            ),
        };
    },
    loader: ({ context }) => {
        // Every tab's query runs, for their counts
        context.queryClient.query(context.allNewslettersQuery).catch(doNothing());
        context.queryClient.query(context.activeNewslettersQuery).catch(doNothing());
        context.queryClient.query(context.inactiveNewslettersQuery).catch(doNothing());
    },
    component: Layout,
});
